import React from 'react';
import { FacebookIcon, YoutubeIcon, InstagramIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
const columns = [{
  title: 'Pratiquer',
  links: ['Les six classes', 'Trouver une base', 'Devenir pilote', 'Emmener un passager', 'Voyager en ULM']
}, {
  title: 'Encadrer',
  links: ['Devenir instructeur', 'Gérer un club', 'Structures affiliées', 'Formations fédérales']
}, {
  title: 'Sport & sécurité',
  links: ['Compétitions', 'Équipes de France', 'Retours d’expérience', 'Fiches sécurité']
}, {
  title: 'La Fédération',
  links: ['Nos missions', 'Comité directeur', 'Délégués départementaux', 'Assurance fédérale', 'Presse']
}];
export function SiteFooter() {
  return <footer className="bg-white" data-id="element-202" data-mp="2ylewelleac7p">
      <section id="federation" className="border-t border-line py-16 lg:py-20" data-id="element-203" data-mp="11rbtebo068gd">
        <div className="mx-auto grid max-w-shell gap-10 px-5 lg:grid-cols-[1fr_1.4fr] lg:gap-20 lg:px-8" data-id="element-204" data-mp="11oxx5zhl6q78">
          <div data-id="element-205" data-mp="wqe6jls1sq8j">
            <Logo className="h-14 w-14" data-id="element-206" data-mp="15r4zcqu3ywmh" />
            <h2 className="ffp-display mt-5 text-2xl font-extrabold text-ink lg:text-[30px]" data-id="element-207" data-mp="15q26weh50m4g">
              Une fédération, six classes, une seule mission : que voler reste simple et sûr.
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-ink/65" data-id="element-208" data-mp="vu8qul47mahx">
              Délégataire du ministère chargé des Sports pour l’ULM, la FFPLUM représente les pilotes auprès de
              la DGAC, forme les instructeurs, anime la culture de sécurité et organise la compétition
              nationale.
            </p>
            <div className="mt-6 flex flex-wrap gap-5 text-[14px] font-medium text-navy" data-id="element-209" data-mp="1tiae12obbiv7">
              <a href="#federation" className="ffp-focus inline-flex items-center gap-2" data-id="element-210" data-mp="1epgzbjgv76rl">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-211" data-mp="1jotinu8j1vpf" />
                contact@ffplum.fr
              </a>
              <a href="#federation" className="ffp-focus inline-flex items-center gap-2" data-id="element-212" data-mp="27ee8mx33lt87">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-213" data-mp="2c8s572thy6eg" />
                01 49 81 74 43
              </a>
            </div>
          </div>

          <nav aria-label="Plan du site" className="grid grid-cols-2 gap-8 sm:grid-cols-4" data-id="element-214" data-mp="2h4w79kjt9l3i">
            {columns.map(column => <div key={column.title} data-id="element-215" data-mp="2d0eq7t4u5lwf">
                <h3 className="ffp-display text-[12px] font-bold uppercase tracking-wider text-ink/45" data-id="element-216" data-mp="283ery4e89nfv">
                  {column.title}
                </h3>
                <ul className="mt-4 space-y-2.5" data-id="element-217" data-mp="235d1gyeh2lud">
                  {column.links.map(link => <li key={link} data-id="element-218" data-mp="1yc0ojlj5o3hg">
                      <a href="#federation" className="ffp-focus text-[14px] text-ink/70 transition-colors duration-150 ease-soft hover:text-azure" data-id="element-219" data-mp="1tdz4oydwo04x">
                        {link}
                      </a>
                    </li>)}
                </ul>
              </div>)}
          </nav>
        </div>
      </section>

      <div className="border-t border-line" data-id="element-220" data-mp="3r2m4xlz57fyr">
        <div className="mx-auto flex max-w-shell flex-col gap-4 px-5 py-6 sm:flex-row sm:items-center sm:justify-between lg:px-8" data-id="element-221" data-mp="3r3xa9q88kvrz">
          <p className="text-[13px] text-ink/50" data-id="element-222" data-mp="4uw2jktqkqtr">
            © 2026 Fédération Française d’ULM — 96 bis rue Marc Sangnier, 94700 Vitry-sur-Seine
          </p>
          <div className="flex items-center gap-4" data-id="element-223" data-mp="8veurfzjjywh">
            <a href="#federation" aria-label="Facebook" className="ffp-focus text-ink/55 hover:text-azure" data-id="element-224" data-mp="38buyotagc5ol">
              <FacebookIcon className="h-[18px] w-[18px]" data-id="element-225" data-mp="3d9mpfjzd1lr7" />
            </a>
            <a href="#federation" aria-label="YouTube" className="ffp-focus text-ink/55 hover:text-azure" data-id="element-226" data-mp="3hc9mq0esvyvs">
              <YoutubeIcon className="h-[18px] w-[18px]" data-id="element-227" data-mp="3m39mddfb0v1z" />
            </a>
            <a href="#federation" aria-label="Instagram" className="ffp-focus text-ink/55 hover:text-azure" data-id="element-228" data-mp="3m4klgzxt1emr">
              <InstagramIcon className="h-[18px] w-[18px]" data-id="element-229" data-mp="2tm6zbxltzh3i" />
            </a>
            <span className="h-4 w-px bg-line" aria-hidden="true" data-id="element-230" data-mp="2tkcbobj6davq" />
            <a href="#federation" className="ffp-focus text-[13px] text-ink/50 hover:text-azure" data-id="element-231" data-mp="2ailno5o6ckr8">
              Mentions légales
            </a>
          </div>
        </div>
      </div>
    </footer>;
}